import {useTranslation} from 'react-i18next';

type Props = {
  body: string;
  required: string | boolean;
};
const Label = ({body, required}: Props) => {
  const {t} = useTranslation();

  return (
    <>
      <span>{body}</span>
      {!required && (
        <span className="ml-1.5 inline-flex items-center whitespace-nowrap rounded-full bg-[var(--field-badge-neutral-bg)] px-2 py-px align-middle text-[length:var(--tag-font-size-sm)] font-bold uppercase leading-[1.5] tracking-[var(--tag-tracking)] text-[color:var(--field-badge-neutral-text)]">
          {t('optional')}
        </span>
      )}
    </>
  );
};

export {Label};
